<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper" ref="sidebar">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <li v-bind:class="{'active': menu.isActive}" v-for="(menu, m_index) in menuArray" :id="menu.id" :ref="menu.ref" v-bind:key="'menu-'+m_index">
                <!-- {{menu.isHide}} -->
                <template v-if="!menu.isHide">
                    <template v-if="menu.routerlink['name'] == 'SyncResult'">
                        <template v-if="loginId == 1 || loginId == 122">
                            <router-link v-bind:to="menu.routerlink">
                                <span class="fa-stack fa-lg pull-left">
                                    <i :class="menu.icon"></i>
                                </span>
                                {{ menu.name }}
                            </router-link>
                        </template>
                    </template>
                    <template v-else>
                        <router-link v-show="permissions.includes(menu.permission_name)" v-bind:to="menu.routerlink">
                            <span class="fa-stack fa-lg pull-left">
                                <i :class="menu.icon"></i>
                            </span>
                            {{ menu.name }}
                        </router-link>
                    </template>
                </template>
            </li>
        </ul>
    </div>
    <!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common';
    var self;

    export default {
        name: 'Sidebar',
        mixins: [commonMixins],
        components: {

        },
        data() {
            return {
                loginId: 0,
                isNonVVGDealer: "NO",
                menuArray: [
                    {
                        name: "Dashboard",
                        isActive: false,
                        ref: "dashboard",
                        id: "dash-board",
                        routerlink: {
                            name: "Dashboard"
                        },
                        icon: "fa fa-th fa-stack-1x",
                        permission_name : "dashboard",
                        isHide: false
                    },
                    {
                        name: "Order History",
                        isActive: false,
                        ref: "order-history",
                        id: "order-history",
                        routerlink: {
                            name: "OrderHistory"
                        },
                        icon: "fa fa-shopping-cart fa-stack-1x",
                        permission_name : "manage_order_history",
                        isHide: false
                    },
                    {
                        name: "OPS Calendar",
                        isActive: false,
                        ref: "ops-calendar",
                        id: "ops-calendar",
                        routerlink: {
                            name: "OPSCalendar"
                        },
                        icon: "fa fa-calendar fa-stack-1x",
                        permission_name : "manage_ops_calendar",
                        isHide: false
                    },
                    {
                        name: "Audit Inventory",
                        isActive: false,
                        ref: "audit-inventory",
                        id: "audit-inventory",
                        routerlink: {
                            name: "ListAuditInventory"
                        },
                        icon: "fa fa-file-text fa-stack-1x",
                        permission_name : "manage_audit_inventory",
                        isHide: false
                    },
                    {
                        name: "Customers",
                        isActive: false,
                        ref: "listCustomer",
                        id: "listCustomer",
                        routerlink: {
                            name: "ListCustomer"
                        },
                        icon: "fa fa-users fa-stack-1x",
                        permission_name : "manage_customers",
                        isHide: false
                    },
                    {
                        name: "Users",
                        isActive: false,
                        ref: "listuser",
                        id: "listuser",
                        routerlink: {
                            name: "ListUser"
                        },
                        icon: "fa fa-user fa-stack-1x",
                        permission_name : "manage_users",
                        isHide: false
                    },
                    {
                        name: "Parts",
                        isActive: false,
                        ref: "listParts",
                        id: "listParts",
                        routerlink: {
                            name: "ListParts"
                        },
                        icon: "fa fa-wrench fa-stack-1x",
                        permission_name : "manage_parts",
                        isHide: false
                    },
                    {
                        name: "Form Email Manager",
                        isActive: false,
                        ref: "ListFormEmailManager",
                        id: "ListFormEmailManager",
                        routerlink: {
                            name: "ListFormEmailManager"
                        },
                        icon: "fa fa-envelope fa-stack-1x",
                        permission_name : "manage_email_notification",
                        isHide: false
                    },
                    {
                        name: "Locations",
                        isActive: false,
                        ref: "listlocations",
                        id: "listlocations",
                        routerlink: {
                            name: "LocationsList"
                        },
                        icon: "fa fa-map-marker fa-stack-1x",
                        permission_name : "manage_location",
                        isHide: false
                    },
                    {
                        name: "Role Permission",
                        isActive: false,
                        ref: "rolePermissionList",
                        id: "rolePermissionList",
                        routerlink: {
                            name: "RolePermission"
                        },
                        icon: "fa fa-check fa-stack-1x",
                        permission_name : "manage_role_permissions",
                        isHide: false
                    },
                    {
                        name: "Sync Result",
                        isActive: false,
                        ref: "syncResult",
                        id: "syncResult",
                        routerlink: {
                            name: "SyncResult"
                        },
                        icon: "fa fa-refresh fa-stack-1x",
                        permission_name : "dashboard",
                        isHide: false
                    },
                    {
                        name: "Mobile Application",
                        isActive: false,
                        ref: "mobileApplication",
                        id: "mobileApplication",
                        routerlink: {
                            name: "MobileApplication"
                        },
                        icon: "fa fa-mobile fa-stack-1x",
                        permission_name : "manage_mobile_application",
                        isHide: false
                    },
                ],
                permissions : [],
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            if(self.isNonVVGDealer == "YES") {
                for(var index = 0; index < self.menuArray.length; index++) {
                    if(
                        self.menuArray[index]['permission_name'] == 'manage_audit_inventory'
                        || self.menuArray[index]['permission_name'] == 'manage_mobile_application'
                        || self.menuArray[index]['permission_name'] == 'manage_ops_calendar'
                        || self.menuArray[index]['permission_name'] == 'manage_email_notification'
                        || self.menuArray[index]['permission_name'] == 'manage_role_permissions'
                    ) {
                        self.menuArray[index]['isHide'] = true;
                    }
                }
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginId = userJson['id'];
                self.getUserPermissions();
            }
            $("#menu-toggle").click(function(e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function(e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $("#menu ul").hide();
            });

            $(".tree-toggle").click(function() {
                $(this)
                    .parent()
                    .children("ul.tree")
                    .toggle(200);
            });



            /*$("#menu-toggle").on("click", function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").on("click", function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                /!*$('ul.tree').hide();*!/
                $(this).parent().children('ul.tree').toggle(200);
                if ($(this).children().eq(1).attr('class').indexOf('fa-angle-down') != -1) {
                    $(this).children().eq(1).addClass('fa-angle-up');
                    $(this).children().eq(1).removeClass('fa-angle-down');
                } else {
                    $(this).children().eq(1).removeClass('fa-angle-up');
                    $(this).children().eq(1).addClass('fa-angle-down');
                }
            });*/

        },
        methods: {
            getActiveMenu :function () {
                console.log("called");
            } ,

            initMenu: function () {
                $('#menu ul').hide();
                $('#menu ul').children('.current').parent().show();
                //$('#menu ul:first').show();
                $('#menu li a').click(
                    function () {
                        var checkElement = $(this).next();
                        if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                            return false;
                        }
                        if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                            $('#menu ul:visible').slideUp('normal');
                            checkElement.slideDown('normal');
                            return false;
                        }
                    }
                );
            },
        }
    }

    EventBus.$on("permissions", function(data, permissions) {
        self.permissions = [];
        if (typeof self != "undefined" && typeof permissions != "undefined") {
            for (let i = 0; i < permissions.length; i++) {
                self.permissions.push(permissions[i].name);
            }
        }
    });

    EventBus.$on("menu-selection-changed", function(menuref) {
        if (typeof self != "undefined") {
            for (var i = 0; i < self.menuArray.length; i++) {
                var menuObject = self.menuArray[i];
                if (menuref == menuObject.ref) {
                        menuObject.isActive = true;
                } else {
                    menuObject.isActive = false;
                }
            }
            //console.log(self.$refs[menuref][0].classList);
            //self.$refs[menuref][0].classList.remove('active');
        }
    });
</script>




// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue